import facebook from "../assets/social media icons/facebook.png";
import instagram from "../assets/social media icons/instagram.png";
import linkedin from "../assets/social media icons/linkedin.png";

const icons = [
  {
    id: 1,
    img: facebook,
    link: "https://www.facebook.com/ahmed.aboalawa.9/",
  },
  {
    id: 2,
    img: instagram,
    link: "https://www.instagram.com/ahmed_3liewa16/",
  },
  {
    id: 3,
    img: linkedin,
    link: "https://www.linkedin.com/in/ahmed-eliewa-855886228/",
  },
];
export default icons;
